export const appConfig = {
  mainPageTitle: 'common.main',
  description: 'app.description',
  appName: process.env.VUE_APP_PROJECT_NAME || 'MuskPartners',
  debounceFilter: 1500, // in milliseconds
  xlsExportItemsLimit: 100000,
  dateIntervalLength: 86400000, // 24h
  dateInterval1h: 3600000, // 1h
  filterPrefix: 'filter',
  partnersLimit: 300,
};
